/* eslint-disable camelcase */
import { Component } from 'react';
import PerformanceDetails from './performance-details';
import BonusDetails from './bonus-details';
import FurtherInformation from './further-information';

class IncentivePerformance extends Component {
  render() {
    const { data } = this.props;
    const { bonus_points_enabled, bonus_points_display } = data;

    return (
      <div className='incentive-performance'>
        <PerformanceDetails
          data={data}
        />
        { bonus_points_enabled && bonus_points_display && (
          <BonusDetails
            data={data}
          />
        )}
        <FurtherInformation
          data={data}
        />
      </div>
    );
  }
}

export default IncentivePerformance;
